export const appName = 'sales';
